/* NEWLUNA — product page: variants, gallery, zoom, lightbox, sticky add to bag, recommendations. */
(function () {
  'use strict';
  function boot() {
    var N = window.Newluna, $ = N.$, $$ = N.$$;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    $$('[data-product-root]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var json = JSON.parse(($('[data-product-json]', root) || {}).textContent || '{}');
      var variants = json.variants || [];
      var form = $('form[data-product-form]', root);
      var idInput = $('[data-variant-id]', root);
      var atc = $('[data-atc]', root), atcLabel = $('[data-atc-label]', root);
      var sticky = $('[data-sticky-atc]', root);

      /* ---------- price markup (mirrors snippets/price.liquid) ---------- */
      function priceHTML(v, large) {
        var L = N.launch || {}, fm = N.formatMoney, sale = !!N.showCompare && v.compare > v.price;
        var h = '<div class="price' + (large ? ' price--l' : '') + (sale ? ' price--sale' : '') + '" data-price>';
        if (L.enabled) h += '<span class="price__launch" data-launch-only><span class="visually-hidden">Launch price</span>' + fm(Math.round(v.price * (100 - L.percent) / 100)) + '</span>';
        h += '<span class="price__now">' + (L.enabled ? '<span class="visually-hidden launch-label">Regular price</span>' : '') + fm(v.price) + '</span>';
        if (sale) h += '<s class="price__compare"><span class="visually-hidden">Was</span>' + fm(v.compare) + '</s>';
        if (large && L.enabled) h += '<span class="price__badge" data-launch-only>−' + L.percent + '%</span>';
        if (large && sale) h += '<span class="price__badge price__badge--sale" data-launch-hide>Save ' + Math.round((v.compare - v.price) * 100 / v.compare) + '%</span>';
        return h + '</div>';
      }

      /* ---------- variants ---------- */
      function selectedOptions() {
        var byName = {};
        $$('[data-option-input]', root).forEach(function (inp) {
          if (inp.type === 'radio' && !inp.checked) return;
          byName[inp.name] = inp.value;
        });
        var out = [];
        for (var i = 1; i <= 3; i++) if (byName['option' + i] !== undefined) out.push(byName['option' + i]);
        return out;
      }
      function findVariant(opts) {
        return variants.filter(function (v) { return opts.every(function (o, i) { return v.options[i] === o; }); })[0];
      }
      function markAvailability(opts) {
        $$('fieldset.opt', root).forEach(function (fs) {
          var idx = parseInt(fs.getAttribute('data-option-index'), 10);
          $$('input[type="radio"]', fs).forEach(function (inp) {
            var test = opts.slice();
            test[idx] = inp.value;
            var v = findVariant(test);
            inp.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      }
      function update(userChange) {
        var opts = selectedOptions();
        var v = findVariant(opts);
        markAvailability(opts);
        $$('fieldset.opt', root).forEach(function (fs) {
          var c = $('input:checked', fs), lab = $('[data-option-label]', fs);
          if (c && lab) lab.textContent = c.value.replace(' / Electrical outlet(USB)', '');
        });
        if (!v) {
          atc.disabled = true;
          atcLabel.textContent = 'Unavailable';
          if (sticky) $('[data-sticky-add]', sticky).disabled = true;
          return;
        }
        idInput.value = v.id;
        atc.disabled = !v.available;
        atcLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
        var pw = $('[data-price-wrap]', root);
        if (pw) pw.innerHTML = priceHTML(v, true);
        if (sticky) {
          var sp = $('[data-sticky-price]', sticky);
          if (sp) sp.innerHTML = priceHTML(v, false);
          var sv = $('[data-sticky-variant]', sticky);
          if (sv) sv.textContent = v.title.replace(' / Electrical outlet(USB)', '');
          $('[data-sticky-add]', sticky).disabled = !v.available;
        }
        if (userChange) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
          if (v.media) gallery.goToMedia(v.media);
        }
      }
      $$('[data-option-input]', root).forEach(function (inp) {
        inp.addEventListener('change', function () { update(true); });
      });
      $$('[data-opt-more]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          var list = b.previousElementSibling;
          if (list) list.classList.remove('is-collapsed');
          b.remove();
        });
      });

      /* ---------- quantity ---------- */
      var qtyField = $('[data-qty-field]', root);
      $$('[data-qty-btn]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(qtyField.value, 10) || 1) + parseInt(b.getAttribute('data-qty-btn'), 10));
          qtyField.value = n;
        });
      });

      /* ---------- gallery ---------- */
      var gallery = (function () {
        var track = $('[data-gallery-track]', root);
        if (!track) return { goToMedia: function () {}, current: function () { return 0; } };
        var slides = $$('.gallery__slide', track), dots = $$('.gallery__dots span', root), thumbs = $$('[data-thumb]', root);
        var idx = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-current'); }));
        function setActive(i) {
          idx = i;
          slides.forEach(function (s, j) { s.classList.toggle('is-current', j === i); });
          dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
          thumbs.forEach(function (t, j) { if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
          var t = thumbs[i];
          if (t && t.scrollIntoView && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
            t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
          }
        }
        function go(i, smooth) {
          i = (i + slides.length) % slides.length;
          track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false || N.reduceMotion ? 'auto' : 'smooth' });
          setActive(i);
        }
        var raf;
        track.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            if (i !== idx && slides[i]) setActive(i);
          });
        }, { passive: true });
        var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
        if (prev) prev.addEventListener('click', function () { go(idx - 1); });
        if (next) next.addEventListener('click', function () { go(idx + 1); });
        thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-thumb'), 10)); }); });
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
        });
        // hover zoom (desktop)
        if (fine && !N.reduceMotion) {
          slides.forEach(function (s) {
            var img = $('img', s);
            if (!img) return;
            s.addEventListener('pointermove', function (e) {
              var r = s.getBoundingClientRect();
              img.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
              img.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
              s.classList.add('is-zooming');
            });
            s.addEventListener('pointerleave', function () { s.classList.remove('is-zooming'); });
          });
        }
        slides.forEach(function (s, i) {
          var img = $('img', s);
          if (img) img.addEventListener('click', function () { lightbox.open(i); });
        });
        if (idx > 0) requestAnimationFrame(function () { go(idx, false); });
        else setActive(0);
        return {
          goToMedia: function (mediaId) {
            var i = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(mediaId); });
            if (i > -1) go(i);
          },
          current: function () { return idx; }
        };
      })();
      var openBtn = $('[data-gallery-open]', root);
      if (openBtn) openBtn.addEventListener('click', function () { lightbox.open(gallery.current()); });

      /* ---------- lightbox ---------- */
      var lightbox = (function () {
        var box = $('[data-lightbox]', root);
        var media = (json.media || []).filter(function (m) { return m.src; });
        if (!box || !media.length) return { open: function () {} };
        var img = $('[data-lightbox-img]', box), scroller = $('[data-lightbox-scroller]', box);
        var i = 0, last = null;
        function show(n) {
          i = (n + media.length) % media.length;
          box.classList.remove('is-zoomed');
          img.src = media[i].src;
        }
        function open(slideIndex) {
          var all = json.media || [];
          var target = all[slideIndex];
          var n = target ? media.findIndex(function (m) { return m.id === target.id; }) : 0;
          last = document.activeElement;
          show(Math.max(0, n));
          box.classList.add('is-open');
          box.setAttribute('aria-hidden', 'false');
          N.lockScroll(true);
          setTimeout(function () { $('[data-lightbox-close]', box).focus(); }, 30);
        }
        function close() {
          box.classList.remove('is-open', 'is-zoomed');
          box.setAttribute('aria-hidden', 'true');
          N.lockScroll(false);
          if (last) last.focus();
        }
        img.addEventListener('click', function (e) {
          var zoomed = box.classList.toggle('is-zoomed');
          if (zoomed) {
            var r = img.getBoundingClientRect();
            var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
            requestAnimationFrame(function () {
              scroller.scrollLeft = fx * scroller.scrollWidth - scroller.clientWidth / 2;
              scroller.scrollTop = fy * scroller.scrollHeight - scroller.clientHeight / 2;
            });
          }
        });
        $('[data-lightbox-close]', box).addEventListener('click', close);
        var p = $('[data-lightbox-prev]', box), nx = $('[data-lightbox-next]', box);
        if (p) p.addEventListener('click', function () { show(i - 1); });
        if (nx) nx.addEventListener('click', function () { show(i + 1); });
        box.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') close();
          if (e.key === 'ArrowRight') show(i + 1);
          if (e.key === 'ArrowLeft') show(i - 1);
          N.trapFocus(box, e);
        });
        return { open: open };
      })();

      /* ---------- sticky add to bag ---------- */
      if (sticky && atc) {
        var stickyBtn = $('[data-sticky-add]', sticky);
        var stickyShown = null, stickyTick = false;
        var checkSticky = function () {
          stickyTick = false;
          var show = atc.getBoundingClientRect().bottom < 0;
          if (show === stickyShown) return;
          stickyShown = show;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          stickyBtn.tabIndex = show ? 0 : -1;
        };
        window.addEventListener('scroll', function () { if (!stickyTick) { stickyTick = true; requestAnimationFrame(checkSticky); } }, { passive: true });
        window.addEventListener('resize', checkSticky, { passive: true });
        checkSticky();
        stickyBtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
        });
      }

      /* ---------- plug type for the visitor's country ---------- */
      if (!json.hasVariantParam && N.preferredPlug) {
        $$('fieldset.opt', root).forEach(function (fs) {
          var legend = $('.opt__legend', fs);
          if (!legend || !/plug/i.test(legend.textContent)) return;
          var want = N.preferredPlug();
          var inp = $$('input[type="radio"]', fs).filter(function (x) { return x.value === want; })[0];
          if (inp && !inp.checked) { inp.checked = true; update(false); }
        });
      }
      update(false);
    });

    /* ---------- recommendations (Shopify's related products) ---------- */
    $$('[data-recs]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.dataset.loaded) return;
      el.dataset.loaded = '1';
      var load = function () {
        fetch(url).then(function (r) { return r.text(); }).then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recs]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
        io.observe(el);
      } else load();
    });
  }
  if (window.Newluna && window.Newluna.$) boot(); else document.addEventListener('newluna:ready', boot);
})();
